// @ts-nocheck
import { get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, CreditCardDto } from "@insite/client-framework/Types/ApiModels";
import {
    InvoicePaymentDto,
    InvoicePaymentOption,
} from "@store/Framework/Store/Pages/AccountBalance/AccountBalanceReducer";

const endpoint = `/api/v1/invoicePayment`;

export interface AccountBalanceReturn extends BaseModel {
    paymentSuccess: boolean;
    success: boolean;
    transactionNumber: string;
    updateErpSuccess: boolean;
}
export type TokenData = {
    card_type: string;
    first_name: string;
    first_six_digits: string;
    full_name: string;
    issuer_identification_number: string;
    last_four_digits: string;
    token: string;
};

export interface SpreedlyInvoicePayment {
    creditCard?: CreditCardDto;
    referenceNumber?: string;
    transactionId?: string;
    amount: number;
    payerId?: string;
    storePaymentProfile: boolean;
    fingerprint?: string;
    paymentOptions: InvoicePaymentOption[];
    isPaymentProfile: boolean;
    paymentProfileId?: string;
    browserInfo?: string;
}

export const submitAccountBalancePayment = (payment: SpreedlyInvoicePayment) => {
    return post<SpreedlyInvoicePayment, AccountBalanceReturn>(endpoint, payment);
};

export const getInvoicePayments = async () => {
    const response = await get<InvoicePaymentDto>(`${endpoint}/`);
    const editablePaymentOptions = response.payments.map((option: InvoicePaymentOption) => {
        return { ...option, isEditing: false, paymentAmount: option.balanceDue };
    });
    return { ...response, payments: editablePaymentOptions };
};
